
























import { Vue, Component, Model, Prop } from 'vue-property-decorator';

import DatepickerPopup from './DatepickerPopup.vue';

import { getTodayDate } from '@/utils/date';
import { ISODateRange, ISOMonth, ISOCalendarDate } from '@/utils/date/types';

@Component({
    components: {
        DatepickerPopup,
    }
})
export default class DatepickerEntry extends Vue {
    @Model('update:range', { required: true }) readonly range!: ISODateRange
    @Prop({ }) readonly initialMonth!: ISOMonth

    get startModel() {
        return this.range.start
    }

    set startModel(start: ISOCalendarDate) {
        const newRange: ISODateRange = {
            start,
            end: this.endModel,
        }

        this.$emit('update:range', newRange)
    }

    get endModel() {
        return this.range.end
    }

    set endModel(end: ISOCalendarDate) {
        const newRange: ISODateRange = {
            start: this.startModel,
            end,
        }

        this.$emit('update:range', newRange)
    }

    get minStartDate() {
        return getTodayDate();
    }

    get minEndDate() {
        return this.startModel || this.minStartDate;
    }
}
